import { ErrorResolution } from '../../../app/common/errorResolution/errorResolution';

export enum EkycServiceActionType {
    UNLINK_EKYCSERVICE_REQUEST = 'USERS_UNLINK_EKYCSERVICE_REQUEST',
    UNLINK_EKYCSERVICE_SUCCESS = 'USERS_UNLINK_EKYCSERVICE_SUCCESS',
    UNLINK_EKYCSERVICE_FAILURE = 'USERS_UNLINK_EKYCSERVICE_FAILURE',
}

export type EkycServiceAction =
    | { type: EkycServiceActionType.UNLINK_EKYCSERVICE_SUCCESS; payload: { clientId: string } }
    | { type: EkycServiceActionType.UNLINK_EKYCSERVICE_REQUEST; payload: {} }
    | {
          type: EkycServiceActionType.UNLINK_EKYCSERVICE_FAILURE;
          payload: { errorResolution: ErrorResolution };
      };
